export default __webpack_public_path__ + "static/media/AwesomeAir_10.e5ec1721.png";